// src/widgets/table/ITableWidget.ts
/**
 * CSS-ключ для TableWidget (используется при поиске в DOM).
 */
const TABLE_CSS_KEY = 'im-table';
/**
 * Уникальный ключ виджета (идентификатор в реестрах/провайдерах).
 */
const TABLE_WIDGET_KEY = 'Table';
/** Пространство имен команд таблиц */
const TABLE_NS = "table";
/**
 * Перечень серверных команд для TableWidget.
 * Используется при обработке команд, приходящих с сервера.
 */
var TableServerCmd;
(function (TableServerCmd) {
    /** Перезагрузить одну строку по id (→ "reload-row") */
    TableServerCmd["reload_row"] = "reload-row";
    /** Вставить группу строк (→ "insert-group") */
    TableServerCmd["insert_group"] = "insert-group";
    /** Полностью перезагрузить таблицу (→ "reload") */
    TableServerCmd["reload"] = "reload";
    /** Удалить выбранные строки (→ "delete-rows") */
    TableServerCmd["delete_rows"] = "delete-rows";
    /** Полностью перезагрузить tbody таблицы (→ "reload-tbody") */
    TableServerCmd["reload_tbody"] = "reload-tbody";
    /** Сохранить и вставить новую строку (→ "save-insert-row") */
    TableServerCmd["save_insert_row"] = "save-insert-row";
    /** Обновить существующую строку (→ "update-row") */
    TableServerCmd["update_row"] = "update-row";
    /** Начать редактирование в форме (→ "start-edit-form") */
    TableServerCmd["start_edit_form"] = "start-edit-form";
    /** Начать редактирование строки (→ "start-edit") */
    TableServerCmd["start_edit"] = "start-edit";
    /** Вставить строки из буфера (→ "paste-rows") */
    TableServerCmd["paste_rows"] = "paste-rows";
    /** Получить форму вставки новой строки (→ "get-insert-form") */
    TableServerCmd["get_insert_form"] = "get-insert-form";
    /** Получить шаблон вставки строки (→ "get-insert-row") */
    TableServerCmd["get_insert_row"] = "get-insert-row";
    /** Открыть фильтр таблицы (→ "open-filter") */
    TableServerCmd["open_filter"] = "open-filter";
    /** Пользовательская команда (→ "custom") */
    TableServerCmd["custom"] = "custom";
    /** Удалить выбранные папки (→ "delete-folders") */
    TableServerCmd["delete_folders"] = "delete-folders";
    /** Переместить строки в другую группу (→ "change-group") */
    TableServerCmd["change_group"] = "change-group";
    /** Открыть редактирование папки (→ "open-edit-folder") */
    TableServerCmd["open_edit_folder"] = "open-edit-folder";
    /** Изменилось множество отмеченных строк (→ "checked-rows-changed") */
    TableServerCmd["checked_rows_changed"] = "checked-rows-changed";
    /** Событие изменения данных таблицы (→ "table-onchanged") */
    TableServerCmd["table_onchanged"] = "table-onchanged";
    /** Переместить выбранные строки вверх (→ "rowsmoveup") */
    TableServerCmd["rowsmoveup"] = "rowsmoveup";
    /** Переместить выбранные строки вниз (→ "rowsmovedown") */
    TableServerCmd["rowsmovedown"] = "rowsmovedown";
})(TableServerCmd || (TableServerCmd = {}));
/**
 * События изменения данных таблицы,
 * передаваемые на серер через onDataChanged().
 */
var TableServerEvents;
(function (TableServerEvents) {
    /** Перезагружена одна строка */
    TableServerEvents["reloadrow"] = "reloadrow";
    /** Полностью перезагружена таблица */
    TableServerEvents["reload"] = "reload";
    /** Вставлена новая строка */
    TableServerEvents["insertrow"] = "insertrow";
    /** Обновлена существующая строка */
    TableServerEvents["updaterow"] = "updaterow";
    /** Вставлена группа строк */
    TableServerEvents["insertgroup"] = "insertgroup";
})(TableServerEvents || (TableServerEvents = {}));
// Хелпер для _tpk_* hidden-инпутов
function getTpk(root, tableKey, name) {
    return root.querySelector(`input[data-key="_tpk_${tableKey}__${name}"]`);
}
function readTpk(root, tableKey, name) {
    return getTpk(root, tableKey, name)?.value ?? null;
}
function writeTpk(root, tableKey, name, value) {
    const el = getTpk(root, tableKey, name);
    if (el) {
        el.value = value;
        el.dispatchEvent(new Event("change", { bubbles: true }));
    }
}

export { TABLE_CSS_KEY, TABLE_NS, TABLE_WIDGET_KEY, TableServerCmd, TableServerEvents, getTpk, readTpk, writeTpk };
